import { Component, OnInit, ViewChild, HostBinding } from '@angular/core';
import { BarComponent } from '../bar/bar.component';

@Component({
  selector: 'bar-group',
  templateUrl: './bar-group.component.html',
  styleUrls: ['./bar-group.component.css']
})
export class BarGroupComponent implements OnInit {

  @ViewChild('bar', {static: false}) bar:BarComponent;
  
  @HostBinding("style.left" ) left:string = '38px';

  public setX( x:number ){
    this.left = x + 'px';
  }
  //public x:number;
  
  constructor() { }

  ngOnInit() {
  }

}
